<template>
  <RegionIssueOverlay>
    <IssueLocationShaftsV2Sets
      v-if="isType('overview') || isType('sets')"
      :inspectionId="inspectionId"
      :issueNavBackRoute="issueNavBackRoute"
      :organisationId="organisationId"
      :setId="setId"
      :shaftId="shaftId"
    />
    <IssueLocationShaftsV2
      v-else
      :inspectionId="inspectionId"
      :issueNavBackRoute="issueNavBackRoute"
      :organisationId="organisationId"
      :shaftId="shaftId"
    />
  </RegionIssueOverlay>
</template>
<script setup>
import { computed } from 'vue';
import { useRoute } from 'vue-router';

import IssueLocationShaftsV2 from '@/components/shaftsV2/location/issue_location_diagram.vue';
import IssueLocationShaftsV2Sets from '@/components/shaftsV2/location/issue_location_sets.vue';
import RegionIssueOverlay from '@/components/regions/regions_issue_overlay.vue';

defineProps({
  organisationId: { type: String, required: true },
  inspectionId: { type: String, required: true },
  shaftId: { type: String, required: true },
  issueId: { type: String, required: false, default: null },
  stationId: { type: String, required: false, default: null },
  setNumber: { type: String, required: false, default: null },
  setId: { type: String, required: false, default: null },
});

const route = useRoute();

// Set back route based on props
const issueNavBackRoute = computed(() => {
  switch (true) {
    case isType('sets') && !isType('overview'):
      return 'shaftV2RegionsIssuesTypeSet';
    case isType('overview'):
      return Object.hasOwn(route.params, 'setGroupId') ? 'shaftV2RegionsIssuesTypeOverviewGroupId' : 'shaftV2RegionsIssuesTypeOverviewGroup';
    case isType('stations'):
      return 'shaftV2RegionsIssuesTypeStation';
    default:
      return 'shaftV2RegionsIssuesTypeHme';
  }
});

function isType(type) {
  return route.fullPath.includes(type);
}
</script>
